import { useRef, useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import JobList from '../job Components/JobList';
import Notification from '../shared/Notification';
import styles from './home.module.css'; // Use CSS modules
import NavHeader from '../shared/Nav-Header';
import logo from '../images/logo.png';
import School from '../shared/School';
import City from '../shared/City';
import Footer from '../shared/Footer';

const Home = () => {
    const [notification, setNotification] = useState('');
    const [jobs, setJobs] = useState([]);
    const [appliedJobs, setAppliedJobs] = useState([]);
    const jobsRef = useRef(null);
    const navigate = useNavigate();
    const token = useMemo(() => localStorage.getItem('token'), []);
    const [membersCount, setMembersCount] = useState(0);

    useEffect(() => {
        if (!token) {
            localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
            navigate('/signup');
            return;
        }
        
        const message = localStorage.getItem('notification');
        if (message) {
            setNotification(message);
            localStorage.removeItem('notification');
        }

        const fetchJobs = async () => {
            try {
                const response = await axios.get('/api/jobs/get-all-jobs', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                // console.log(response.data)
                setJobs(response.data);
            } catch (error) {
                // console.error('Error fetching jobs:', error);
            }
        };

        // const fetchAppliedJobs = async () => {
        //     try {
        //         const response = await axios.get('/api/jobs/applied-jobs', {
        //             headers: {
        //                 Authorization: `Bearer ${token}`
        //             }
        //         });
        //         setAppliedJobs(response.data); // Ensure backend returns an array of job IDs
        //         // console.log('response.data:home', response.data); // Debugging to check if the data is correct
        //     } catch (error) {
        //         const errorMessage = error.response?.data?.message || 'Error fetching applied jobs';
        //         console.error(errorMessage);
        //     }
        // };

        const fetchMembers = async () => {
            try {
                const response = await axios.get('/api/general/get-members-count', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setMembersCount(response.data.count - 28);
            } catch (error) {
                // console.error('Error fetching members count:', error);
            }
        };

        fetchJobs();
        // fetchAppliedJobs();
        // fetchMembers();
    }, [navigate]);

    const handleApplyJob = async (jobId) => {
        try {
            await axios.post('/api/jobs/apply-job', { jobId }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setNotification('Job applied successfully!');
            setAppliedJobs(prevAppliedJobs => [...prevAppliedJobs, jobId]); // Update applied jobs
        } catch (error) {
            setNotification(error.response.data.message);
        }
    };

    const handleCloseNotification = () => {
        setNotification('');
    };
    const handleScrollToJobs = () => {
        if (jobsRef.current) {
            jobsRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };
    

    return (
        <div className={styles.home}>
            <div className={styles.heroContainer}>
                <div className={styles.backgroundImage}></div>
                <div className={styles.gradientOverlay}></div>
                
                <div className={styles.heroContent}>
                    <div className={styles.heroText}>
                        <h1 className={styles.heroTitle}>
                            <div>
                            <img className={styles.logo}src={logo} alt="Logo" />
                            </div>
                            {/* <div className={styles.navbarLogo}>MERILITE</div> */}
                            Your <span className={styles.highlight}>ONE STOP</span> to learning{' '}
                            <span className={styles.highlight}>Everything</span>
                        </h1>
                        <p className={styles.heroSubtext}>
                            Discover amazing connections and craft your career journey
                        </p>
                        <div className={styles.ctaButtons}>
                            <button className={styles.primaryCta} onClick={handleScrollToJobs}>Get Started</button>
                            <button className={styles.secondaryCta} onClick={handleScrollToJobs}>Learn More</button>
                        </div>
                    </div>
                </div>
                
                <div className={styles.scrollIndicator} onClick={handleScrollToJobs}>
                    <div className={styles.scrollArrow}></div>
                </div>
            </div>
            
            <NavHeader />
            
            {notification && (
                <Notification message={notification} onClose={handleCloseNotification} />
            )}
            {/* <h3 className={styles.membersCount}>Members Joined :: {membersCount}</h3> */}
            <div ref={jobsRef} className={styles.content}>
                {/* <JobList jobs={jobs} appliedJobs={appliedJobs} onApplyJob={handleApplyJob} /> */}
            </div>
            <School/>
            <City/>
            <Footer />
        </div>
    );
};

export default Home;